const addMemberWidget = {
  openButton: "Bæta við liðsmanni",
  pendingInvitations_one: "{{count}} boð í bið",
  pendingInvitations_other: "{{count}} boð í bið",
  heading: "Bæta liðsmanni við verkefni",
  searchPlaceholder: "Sláðu inn nafn eða netfang...",
  clearButton: "Hreinsa",
  noMatches: {
    alreadyMember: "Þessi notandi er nú þegar í þessu verkefni",
    noneAvailable: "Engir notendur í boði til að bæta við",
    typeFullEmail: "Engir notendur fundust — sláðu inn fullt netfang til að senda boð",
    noneFound: "Engir notendur fundust",
  },
  notInOrgText: "er ekki í þinni stofnun",
  clickToInvite: "— smelltu til að senda boð",
  roleLabel: "Hlutverk:",
  roleResearcher: "Rannsakandi",
  rolePi: "Ábyrgðarmaður (PI)",
  expiryLabel: "Rennur út eftir:",
  expiryOptions: {
    hours24: "24 klukkustundir (1 dagur)",
    hours72: "72 klukkustundir (3 dagar)",
    hours168: "168 klukkustundir (7 dagar)",
    hours336: "336 klukkustundir (14 dagar)",
    hours720: "720 klukkustundir (30 dagar)",
  },
  addButton: "Bæta við verkefni",
  adding: "Bæti við...",
  sendButton: "Senda boð",
  sending: "Sendi...",
  pendingInvitationsHeading: "Boð í bið",
  openInvite: "Opið boð",
  expiresOn: "rennur út {{date}}",
  revokeButton: "Afturkalla",
  revokeConfirm: "Afturkalla þetta boð?",
  loadingInvitations: "Sæki boð...",
  inviteLinkShownOnce: "Boðshlekkur (sýndur einu sinni)",
  dismissButton: "Hunsa",
  messages: {
    assignSuccess: "{{name}} bætt við verkefnið sem {{role}}.",
    assignError: "Ekki tókst að bæta notanda við.",
    inviteSuccess: "Boð stofnað fyrir {{email}}. Afritaðu hlekkinn núna — hann verður ekki sýndur aftur.",
    inviteError: "Ekki tókst að senda boð.",
    revokeError: "Ekki tókst að afturkalla boð.",
    linkCopied: "Boðshlekkur afritaður!",
  },
};

export default addMemberWidget;
